import { render, staticRenderFns } from "./LeaveAddForm.vue?vue&type=template&id=32f3d8d0&scoped=true&"
import script from "./LeaveAddForm.vue?vue&type=script&lang=js&"
export * from "./LeaveAddForm.vue?vue&type=script&lang=js&"
import style0 from "./LeaveAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeaveAddForm.vue?vue&type=style&index=1&id=32f3d8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3d8d0",
  null
  
)

export default component.exports